import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import StarSvg from '@src/svgs/fr-star.svg';
import './styles.scss';

export const Score = ({ score, ratings, isEntryPointElement, onClick }) => {
  const isBelowAverage = score < 2.5;
  if (!score) {
    return null;
  }

  return (
    <div
      className={classnames('single-rating', isEntryPointElement && 'single-rating--small')}
      onClick={onClick && onClick}
    >
      <Svg
        className={classnames('single-rating__icon', isBelowAverage && 'single-rating__icon--negative')}
        src={StarSvg}
      />
      <span className="single-rating__number">{parseFloat(score).toFixed(1)}</span>
      {ratings && <span className="single-rating__ratings">({ratings})</span>}
    </div>
  );
};

Score.propTypes = {
  isEntryPointElement: PropTypes.bool,
  onClick: PropTypes.func,
  ratings: PropTypes.number,
  score: PropTypes.number,
};
